import { useLocalStore } from 'hooks/useLocalStore';
import { OpenStore } from 'stores/shared/OpenStore';

export const useOpenStore = (defaultValue = false): OpenStore => {
  return useLocalStore(() => new OpenStore(defaultValue));
};
